import { Row, Col } from "react-bootstrap";
import Pacman from "src/app/components/layout/Pacman";
import { useLastOrderWithImage } from "src/app/hooks";

const ImageGridContainer = () => {
    const { orders, loading } = useLastOrderWithImage();
    if (loading) return <Pacman />;
    return (
        <Row>
            {orders.map((el, index) => (
                <Col sm={4} key={index}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            border: "4px solid var(--kt-primary)",
                            margin: "8px 0",
                            padding: "4px",
                            height: "300px",
                        }}
                    >
                        {el.content?.images && (
                            <img height={220} src={el.content?.images[0]?.largeImageUrl} />
                        )}
                        <span> {el.content?.title}</span>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default ImageGridContainer;
